/* HandyHubThai: customer photos in the booking sheet.
   WhatsApp and LINE links can't carry files, so the chat opens first with a note that
   photos are coming, then "Send photos" hands them to WhatsApp or LINE via the phone's share sheet. */
(function () {
  'use strict';
  var sheet = document.getElementById('booking-sheet');
  var box = sheet && sheet.querySelector('[data-photos]');
  if (!box) return;

  var MAX = 10;
  var photos = [];
  var input = box.querySelector('[data-photo-input]');
  var list = box.querySelector('[data-photo-list]');
  var msg = box.querySelector('[data-photo-msg]');
  var next = sheet.querySelector('[data-photos-next]');
  var shareBtn = next && next.querySelector('[data-photos-share]');
  var shareLabel = shareBtn && shareBtn.querySelector('span');
  var baseLabel = shareLabel ? shareLabel.textContent : '';
  function track(name, data) { if (window.HHT && typeof window.HHT.track === 'function') window.HHT.track(name, data); }
  function files() { return photos.map(function (p) { return p.file; }); }
  function canShare(f) {
    try { return !!(navigator.share && navigator.canShare && navigator.canShare({ files: f })); } catch (e) { return false; }
  }

  function render() {
    list.innerHTML = '';
    photos.forEach(function (item, i) {
      var li = document.createElement('li');
      li.className = 'photos__thumb';
      var img = document.createElement('img');
      img.src = item.url; img.alt = '';
      var rm = document.createElement('button');
      rm.type = 'button'; rm.className = 'photos__remove';
      rm.setAttribute('aria-label', box.getAttribute('data-remove-label') + ' ' + (i + 1));
      rm.innerHTML = '<svg class="icon" viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6 6 18" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"/></svg>';
      rm.addEventListener('click', function () {
        URL.revokeObjectURL(item.url);
        photos.splice(i, 1);
        msg.textContent = '';
        render();
        input.focus();
      });
      li.appendChild(img); li.appendChild(rm);
      list.appendChild(li);
    });
    if (shareLabel) shareLabel.textContent = baseLabel + (photos.length ? ' (' + photos.length + ')' : '');
    if (!photos.length && next) next.hidden = true;
  }

  input.addEventListener('change', function () {
    var picked = Array.prototype.slice.call(input.files || []).filter(function (f) { return /^image\//.test(f.type); });
    var room = MAX - photos.length;
    msg.textContent = picked.length > room ? box.getAttribute('data-limit-msg') : '';
    picked.slice(0, Math.max(room, 0)).forEach(function (f) { photos.push({ file: f, url: URL.createObjectURL(f) }); });
    input.value = '';
    render();
    if (picked.length) track('hht_photos_added', { count: photos.length, placement: 'booking_sheet' });
  });

  // When a chat link is tapped with photos attached: add the note to the pre-filled
  // message (it is always the last part of the link) and show the "send photos" step.
  sheet.addEventListener('click', function (e) {
    var link = e.target.closest('[data-channel-link]');
    if (!link || !photos.length) return;
    var note = box.getAttribute('data-note');
    var href = link.getAttribute('href') || '';
    var isPrefilled = /[?&]text=|\/oaMessage\//.test(href);
    if (note && isPrefilled && href.indexOf(encodeURIComponent(note)) === -1) {
      link.setAttribute('href', href + encodeURIComponent(' ' + note));
    }
    if (next) {
      var share = canShare(files());
      next.querySelector('[data-photos-share-text]').hidden = !share;
      next.querySelector('[data-photos-manual-text]').hidden = share;
      shareBtn.hidden = !share;
      next.setAttribute('data-channel', link.getAttribute('data-channel-link') || '');
      next.hidden = false;
    }
  }, true);

  if (shareBtn) {
    shareBtn.addEventListener('click', function () {
      var f = files();
      if (!canShare(f)) return;
      var channel = next.getAttribute('data-channel') || '';
      navigator.share({ files: f }).then(function () {
        track('hht_photos_shared', { count: f.length, channel: channel, placement: 'booking_sheet' });
      }).catch(function () {});
    });
  }

  sheet.addEventListener('close', function () { if (next) next.hidden = true; });
})();
